import * as types from './types';
import { ContactGroupsService } from '../../services/contact_groups.service';
import { SET_MAIN_NAV_ACTIVE } from '../../../../store/app/types';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import router from '../../../../router';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { HttpClient } from '../../../../services/http/http-client';
// import { GroupService } from '../../../dt-plugins/groups/groups.service';
// import { HttpClient } from '../../../services/http/http-client';
// import { relatedContactService } from '../../booking/services/artists/related-contacts.service';
// import { UPDATE_RELATED_CONTACT, DELETE_RELATED_CONTACT } from '../../../dt-plugins/add-contact-relation/store';

const NavTabModule = getNavTabModule(types.ContactGroupDetails, 'contactGroupDetails');
const group_idr = () => router.currentRoute.params.group_id;

export const contactGroupActions = {
  ...NavTabModule.implementActions(
    'group_id',
    'groups/group_id/tab',
    'groups',
    () => router,
    'contacts',
    (value, key) => {
      return {
        title: value?.group?.group_name ? value.group.group_name : key,
        full_title: value?.group?.group_name ? value.group.group_name : key
      }
    }
  ),
  // Show Sidewindow
  async [types.ContactGroupDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    let { flag, group, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "group_id";
    const itemName = "group";
    const item = payload[itemName];

    if (!item) {
      return;
    }
    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "contactGroupDetails";
    const DetailsAction = types.ContactGroupDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }
    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const detailsData = await ContactGroupsService.getContactGroupsDetails(group.group_id);

    // console.log('contact group Detais:mdsir', detailsData.data);

    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, group) => {
        return {
          ...group,
          ...detailsData.data,
          loading: false,
        };
      }
    );
  },
  async [types.ContactGroupDetails.UPDATE.MULTIPLE]({ dispatch, getters }, payload) {
    const { group_id, ...rest } = payload;
    const groupID = group_id ? group_id : group_idr();

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(groupID, groupDetailsObj => {
      return {
        ...groupDetailsObj,
        ...rest
      };
    });
  },
  async [types.ContactGroupDetails.UPDATE.SINGLE]({ dispatch, getters, commit }, payload) {
    const { name, value } = payload;

    const selectedGroup = getters.contactGroupDetails[group_idr()];

    dispatch(types.ContactGroupDetails.UPDATE.MULTIPLE, {
      group: { ...selectedGroup.group, [name]: value }
    });

    if (["group_name", "comment"].includes(name)) {
      const updatedItems = getters.contactGroups.map(row => {
        return row.group_id == selectedGroup.group.group_id ? { ...row, [name]: value } : row;
      });
      commit(types.ContactGroups.SET.ALL, updatedItems);
    }

    HttpClient.modify("group_id", selectedGroup.group.group_id, name, value, "groups");
  },
  async [types.ContactGroups.FETCH.ALL]({ commit }) {
    const contactGroups = await ContactGroupsService.getContactGroups();
    commit(types.ContactGroups.SET.ALL, contactGroups.data.groups);
  },

  async [types.ContactGroups.DELETE.SINGLE]({ commit, state }, item) {
    let itemsAfterDeleted = state.contactGroups.filter(
      row => row.group_id != item.group_id
    );
    commit(types.ContactGroups.SET.ALL, itemsAfterDeleted);
    const contactGroups = await ContactGroupsService.deleteContactGroup(item.group_id);
  },
  async [types.GroupContactsData.SET.ALL]({ commit, dispatch }, contacts) {
    // commit(types.GroupContactsData.SET.ALL, contacts);
    
    dispatch(types.ContactGroupDetails.UPDATE.MULTIPLE, {
      contacts
    });
  },

  async [types.SelectedContactGroup.SET.SINGLE]({ commit }, payload) {
    console.log('mdsir selected aciotn: ', payload);

    const {
      flag,
      group,
    } = payload;

    commit(SET_MAIN_NAV_ACTIVE, !flag, { root: true });
    if (!group) {
      commit(types.SelectedContactGroup.SET.SINGLE, {});
      return;
    }
    commit(types.SelectedContactGroup.SET.SINGLE, null);
    commit(types.SelectedContactGroupLoading.SET.SINGLE, true);
    const groupDetails = await ContactGroupsService.getContactGroupsDetails(group.group_id);
    commit(types.SelectedContactGroupLoading.SET.SINGLE, false);

    console.log(groupDetails.data);

    commit(types.SelectedContactGroup.SET.SINGLE, groupDetails.data);
  },
}